<template>

<core-panel>

	<template v-slot:head>

		<h1>Most Plays</h1>

		<p>The people most played with.</p>

	</template>

	<template v-slot:body>

		<app-user type="player" :item="item" v-for="(item, index) in mostplays" subdate="Last played with on" count-text="play" :key="index" :dark="true" />

	</template>

</core-panel>

</template>

<script>

import Panel from './../../common/Panel'

export default {

	mixins: [Panel],

	data: function() {

		return {
			detail: 'mostplays',
			mostplays: []
		}

	},

	methods: {

		response: function(json) {

			this.mostplays = json.mostplays

		}

	}

}

</script>